/*
 * Glasnu — productpagina.
 * Aantalstepper en een koopbalk die verschijnt zodra het hoofd-koopblok
 * uit beeld scrollt. Bewust klein en zonder afhankelijkheden.
 */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  /* The sticky CTA opens the real purchase controls. Easify owns the main
     button's validation and cart submission; never submit its form directly. */
  pdp.addEventListener('click', function (event) {
    var sticky = event.target.closest('[data-sticky-submit]');
    if (!sticky || !pdp.contains(sticky)) return;
    event.preventDefault();
    event.stopPropagation();
    var target = pdp.querySelector('.gn-pdp__config') || pdp.querySelector('.gn-buybox');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  /* ---------- Aantalstepper ---------- */
  pdp.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('.gn-qty__input');
    if (!input) return;

    qty.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, Math.min(max, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('change', function () {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = min;
      input.value = Math.max(min, Math.min(max, val));
    });
  });

  /* ---------- Galerij ----------
     De thumbnails wisselen de foto in het grote vak. Het stage-beeld heeft een
     srcset; die moeten we leegmaken voordat we src zetten, anders kiest de
     browser alsnog een bron uit de oude srcset. */
  var gallery = pdp.querySelector('[data-gallery]');
  if (gallery) {
    var stage = gallery.querySelector('.gn-pdp__stage-img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    /* "+"-tegel: klapt de rest van de miniaturen uit. De foto's staan al in de
       HTML, dus er wordt niets nageladen. */
    var toggle = gallery.querySelector('[data-gallery-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = gallery.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        var hidden = toggle.querySelector('.visually-hidden');
        if (hidden) {
          hidden.textContent = expanded
            ? 'Toon minder foto’s'
            : 'Toon alle foto’s';
        }
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!stage) return;

        stage.removeAttribute('srcset');
        stage.removeAttribute('sizes');
        stage.src = thumb.getAttribute('data-src');
        stage.alt = thumb.getAttribute('data-alt') || '';

        thumbs.forEach(function (other) {
          var active = other === thumb;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Varianten ----------
     De selects sturen samen één variant aan: bij elke wijziging zoeken we de
     variant waarvan alle optiewaarden kloppen en werken we prijs, voorraad,
     het verborgen id in het formulier en de foto bij. */
  var picker = pdp.querySelector('[data-variant-picker]');
  var dataEl = picker && picker.querySelector('[data-variant-data]');

  if (picker && dataEl) {
    /* Stilzwijgend terugvallen op een lege lijst was hier een valkuil: dan
       vond de kiezer nooit een variant en gebeurde er bij elke wissel niets.
       Nu blijft het zichtbaar in de console. */
    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      console.error('Glasnu: variantgegevens onleesbaar — de maatkiezer valt terug op het variant-id per optie.', e);
      variants = [];
    }

    var selects = picker.querySelectorAll('[data-option-index]');
    var idInput = pdp.querySelector('#pdp-form input[name="id"]');
    var priceEl = pdp.querySelector('[data-pdp-price]');
    var submit = pdp.querySelector('[data-pdp-submit]');
    var stickyPrice = pdp.querySelector('.gn-sticky-bar__price');
    var stageImg = pdp.querySelector('.gn-pdp__stage-img');

    /* Optiewaarden vergelijken we ongevoelig voor spaties en hoofdletters. Een
       waarde die in de admin als "400 cm" staat en in het thema als "400cm"
       hoort geen lege winkelwagen op te leveren. */
    var normalise = function (value) {
      return String(value == null ? '' : value)
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    };

    var findVariant = function () {
      var chosen = [];
      selects.forEach(function (select) {
        chosen[parseInt(select.dataset.optionIndex, 10)] = normalise(select.value);
      });

      return variants.find(function (variant) {
        if (!variant || !variant.options) return false;
        return chosen.every(function (value, index) {
          return normalise(variant.options[index]) === value;
        });
      });
    };

    /* Bij één optie draagt de gekozen <option> het variant-id zelf. Dat is de
       zekerste bron: er komt geen enkele vergelijking aan te pas. */
    var variantFromOption = function () {
      if (selects.length !== 1) return null;

      var option = selects[0].selectedOptions && selects[0].selectedOptions[0];
      var id = option && option.dataset.variantId;
      if (!id) return null;

      var known = variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
      if (known) return known;

      // Geen bruikbare variantenlijst? Dan is alles wat we nodig hebben ook
      // aan de optie zelf meegegeven, dus prijs en voorraad lopen gewoon mee.
      var data = option.dataset;
      if (!data.price) return { id: id, available: true, partial: true };

      return {
        id: id,
        price: data.price,
        compare_at: data.compareAt || null,
        price_cents: parseInt(data.priceCents, 10),
        available: data.available !== 'false',
        image: data.image || null,
      };
    };

    /* Een combinatie waar geen variant bij hoort (bijv. zwart alleen in 300cm).
       Zonder deze afhandeling bleef het verborgen id op de vórige variant
       staan: de bezoeker ziet zijn keuze, maar legt iets anders in de
       winkelwagen. Het id gaat er dus uit en kopen kan even niet. */
    var applyUnavailable = function () {
      if (idInput) idInput.value = '';

      [submit, pdp.querySelector('[data-sticky-submit]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = true;
        var label = btn.querySelector('span');
        if (label) label.textContent = 'Niet beschikbaar';
      });

      pdp.querySelectorAll('[data-qty] button, [data-qty] input').forEach(function (el) {
        el.disabled = true;
      });
    };

    /* De prijs staat er al opgemaakt; we vervangen alleen de bedragen. Dat
       scheelt een blok HTML in de variantgegevens én houdt de opmaak uit
       /design in stand, ook als die later verandert. */
    var applyPrice = function (variant) {
      if (!priceEl) return;

      var box = priceEl.querySelector('.gn-price');
      if (!box) return;

      var amount = box.querySelector('.gn-price__amount');
      if (amount) amount.textContent = variant.price;

      var compare = box.querySelector('.gn-price__compare');
      if (variant.compare_at) {
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'gn-price__compare';
          if (amount) amount.insertAdjacentElement('afterend', compare);
          else box.appendChild(compare);
        }
        compare.textContent = variant.compare_at;
        box.classList.add('gn-price--promo');
      } else if (compare) {
        compare.remove();
        box.classList.remove('gn-price--promo');
      }
    };

    var apply = function (variant) {
      if (!variant) {
        applyUnavailable();
        return;
      }

      if (idInput) idInput.value = variant.id;

      // Een variant zonder gegevens levert alleen het id; prijs en foto laten
      // we dan staan in plaats van ze leeg te maken.
      if (!variant.partial) {
        applyPrice(variant);
        if (stickyPrice) stickyPrice.textContent = variant.price;
      }

      // De prijsopbouw rekent met de basisprijs van de gekozen variant.
      var priceSummary = pdp.querySelector('[data-price-summary]');
      if (priceSummary && typeof variant.price_cents === 'number') {
        priceSummary.setAttribute('data-base-price', variant.price_cents);
        var baseValue = priceSummary.querySelector('[data-base-price-value]');
        if (baseValue) baseValue.textContent = variant.price;
        if (typeof refreshOptionTotals === 'function') refreshOptionTotals();
      }

      // Koopknop, sticky-balkknop en aantalstepper volgen de voorraad samen.
      var ctaLabel = submit && submit.getAttribute('data-label');
      [submit, pdp.querySelector('[data-sticky-submit]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !variant.available;
        var label = btn.querySelector('span');
        if (label) {
          label.textContent = variant.available
            ? (btn.hasAttribute('data-sticky-submit') ? 'Bekijk en bestel' : ctaLabel || 'In winkelwagen')
            : 'Tijdelijk uitverkocht';
        }
      });

      pdp.querySelectorAll('[data-qty] button, [data-qty] input').forEach(function (el) {
        el.disabled = !variant.available;
      });

      if (stageImg && variant.image) {
        stageImg.removeAttribute('srcset');
        stageImg.removeAttribute('sizes');
        stageImg.src = variant.image;
      }

      // Houd de URL gelijk met de keuze, zodat delen en verversen blijft werken.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    /* Volgorde van zekerheid: eerst de gematchte variant, dan het id dat op de
       optie zelf staat. Pas als we variantgegevens hébben en er echt geen
       combinatie bij past, blokkeren we het bestellen. Zonder gegevens laten we
       de pagina met rust — een kapotte kiezer mag nooit een verkoop tegenhouden. */
    var onChange = function () {
      var variant = findVariant() || variantFromOption();

      if (variant) {
        apply(variant);
        return;
      }

      if (variants.length) {
        applyUnavailable();
      } else {
        console.warn('Glasnu: geen variantgegevens beschikbaar; de koopknop blijft zoals hij was.');
      }
    };

    selects.forEach(function (select) {
      select.addEventListener('change', onChange);
    });
  }

  /* ---------- Prijsopbouw met Easify-opties ----------
     Twee bronnen die elkaar aanvullen; we nemen de hoogste van de twee:

       1. Easify's eigen totaalregel onder de opties. Die kent ook toeslagen
          zonder zichtbaar bedrag, zoals de keuze tussen helder en getint glas.
       2. Onze eigen optelling van de bedragen bij alles wat is aangevinkt.
          Die werkt door als Easify die regel niet toont of achterloopt.

     Beide bewegen mee met de keuze, dus zonder selectie komen ze allebei op
     nul uit. Het verborgen veld _tpo_price is puur nog vangnet voor een pagina
     zonder configurator: Easify vult dat pas bij het toevoegen aan de
     winkelwagen en maakt het daarna niet meer leeg.

     De optelling kent geen enkele klassenaam van de app — hij zoekt vanaf elk
     keuzeveld het blok eromheen waar een bedrag in staat. Een nieuwe optiegroep
     wordt daardoor vanzelf meegenomen.

     Easify hertekent zijn eigen DOM, dus naast de events kijken we met een
     MutationObserver en periodiek mee. */
  var summary = pdp.querySelector('[data-price-summary]');
  var refreshOptionTotals = null;

  if (summary) {
    var optionsRow = summary.querySelector('[data-options-total]');
    var totalEl = summary.querySelector('[data-easify-total-price]');
    var stickyTotal = pdp.querySelector('.gn-sticky-bar__price');
    var moneyFormat = summary.getAttribute('data-money-format') || '€{{amount}}';

    // Shopify's money-format met {{amount}}-achtige tokens; cents in, tekst uit.
    var formatMoney = function (cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var decimals = parts[1];

      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, token) {
        switch (token) {
          case 'amount_no_decimals':
            return whole;
          case 'amount_with_comma_separator':
            return whole + ',' + decimals;
          case 'amount_no_decimals_with_comma_separator':
            return whole;
          case 'amount_with_apostrophe_separator':
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + decimals;
          default:
            // {{amount}} — Shopify's standaard is 1.234,56 in deze winkel.
            return whole + ',' + decimals;
        }
      });
    };

    var basePrice = function () {
      return parseInt(summary.getAttribute('data-base-price'), 10) || 0;
    };

    var config = pdp.querySelector('.gn-pdp__config');

    /* "(€1.234,50)" → 123450 cent. Europees genoteerd: punt is duizendtal,
       komma is decimaal — behalve als er alleen een punt staat met twee
       cijfers erachter, dan is dat de decimaal. */
    var parseAmount = function (text) {
      var match = String(text).match(/-?[\d.,]*\d/g);
      if (!match || !match.length) return null;

      var raw = match[match.length - 1];
      var hasComma = raw.indexOf(',') !== -1;
      var hasDot = raw.indexOf('.') !== -1;
      var normalised;

      if (hasComma && hasDot) {
        normalised = raw.replace(/\./g, '').replace(',', '.');
      } else if (hasComma) {
        normalised = raw.replace(',', '.');
      } else if (hasDot && /\.\d{2}$/.test(raw)) {
        normalised = raw;
      } else {
        normalised = raw.replace(/\./g, '');
      }

      var value = parseFloat(normalised);
      return isNaN(value) ? null : Math.round(value * 100);
    };

    // 3. Het verborgen veld dat Easify meestuurt naar de winkelwagen.
    var chargeFromField = function () {
      var field = document.querySelector('[name*="_tpo_price"]');
      if (!field || !field.value) return null;
      return parseAmount(field.value);
    };

    /* 1. Easify's eigen totaalregel. We zoeken het kleinste element dat de
       tekst draagt, zodat we niet per ongeluk een halve pagina te pakken
       hebben — en verbergen dat daarna, want wij tonen het zelf netter.

       De verwijzing wordt élke keer opnieuw opgebouwd. Easify haalt de regel
       namelijk weg zodra er niets meer is aangevinkt; hielden we de oude
       verwijzing vast, dan bleef de laatst bekende toeslag staan. */
    var chargeNoticeEl = null;

    var findChargeNotice = function () {
      if (!config) return null;
      if (chargeNoticeEl && config.contains(chargeNoticeEl)) return chargeNoticeEl;

      chargeNoticeEl = null;
      var candidates = config.querySelectorAll('div, p, span');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var text = el.textContent || '';
        if (text.length > 200) continue;
        if (!/additional charge|extra kosten|toeslag|meerprijs|selections will add/i.test(text)) continue;
        if (el.querySelector('input, select, img')) continue;
        chargeNoticeEl = el;
      }

      if (chargeNoticeEl) chargeNoticeEl.style.display = 'none';
      return chargeNoticeEl;
    };

    var chargeFromNotice = function () {
      var el = findChargeNotice();
      if (!el) return null;

      /* Een regel zonder bedrag betekent dat Easify hem heeft leeggemaakt in
         plaats van verwijderd — dat is nul toeslag, geen "onbekend". */
      var amount = parseAmount(el.textContent);
      return amount === null ? 0 : amount;
    };

    /* Het bedrag uit een stuk tekst. Easify schrijft toeslagen op twee
       manieren, afhankelijk van het optietype:

         "Komgreep (€17,50)"        → haakjes achter de naam
         "Getint glas + € 50,00"    → los achter de naam

       Haakjes gaan voor, zodat "Glasopvang (set van 2) (€95,00)" op 95 uitkomt
       en niet op 2. Zonder haakjes nemen we het laatste bedrag met euroteken;
       tekst zonder euroteken ("Antraciet RAL 7016") levert niets op. */
    var amountFromText = function (text) {
      if (!text || text.indexOf('€') === -1) return 0;

      var groups = text.match(/\([^)]*€[^)]*\)/g);
      if (groups && groups.length) return parseAmount(groups[groups.length - 1]) || 0;

      var inline = text.match(/€\s*[\d.,]*\d/g);
      if (inline && inline.length) return parseAmount(inline[inline.length - 1]) || 0;

      return 0;
    };

    /* De regel van één gekozen optie. We lopen vanaf het keuzeveld omhoog tot
       we een blok vinden met een bedrag erin, en stoppen zodra dat blok meer
       dan één keuzeveld bevat — dan zitten we in de hele optiegroep en zouden
       we de prijs van een buurman kunnen pakken.

       Deze aanpak kent geen enkele klassenaam van de app, dus een nieuwe
       optiegroep wordt vanzelf meegenomen. */
    var optionRow = function (input, root) {
      var node = input.parentElement;

      for (var step = 0; step < 6 && node && node !== root; step++) {
        var count = node.querySelectorAll('input[type="checkbox"], input[type="radio"]').length;
        if (count > 1) return null;
        if ((node.textContent || '').indexOf('€') !== -1) return node;
        node = node.parentElement;
      }

      return null;
    };

    // Easify's eigen prijselement gaat voor; anders lezen we het uit het label.
    var rowAmount = function (row) {
      var tag = row.querySelector('.tpo_additional-price, .tpo_option-price');
      if (tag) return parseAmount(tag.textContent) || 0;
      return amountFromText(row.textContent || '');
    };

    /* Voorwaardelijke optiegroepen — "Bezorging" hoort alleen bij Bouwpakket —
       verbergt Easify, maar de keuze blijft aangevinkt in de DOM staan. Wat je
       niet ziet, hoort ook niet mee te tellen: anders schuift de prijs van een
       weggeklapte optie mee in het totaal. Geen enkel zichtbaar vlak betekent
       dat het blok is dichtgeklapt. */
    var isVisible = function (el) {
      if (!el) return false;

      // Nul breed of hoog vangt zowel display:none als een dichtgeklapt blok.
      var rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;

      return window.getComputedStyle(el).visibility !== 'hidden';
    };

    /* 2. Onze eigen optelling van alles wat is aangevinkt of gekozen. */
    var readSelection = function () {
      var root = config || pdp;
      var inputs = root.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      var selects = root.querySelectorAll('select');
      if (!inputs.length && !selects.length) return null;

      var total = 0;

      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].checked) continue;
        var row = optionRow(inputs[i], root);
        if (row && isVisible(row)) total += rowAmount(row);
      }

      // Keuzelijsten: het bedrag staat in de tekst van de gekozen regel.
      for (var j = 0; j < selects.length; j++) {
        var option = selects[j].selectedOptions && selects[j].selectedOptions[0];
        if (!option) continue;

        var holder = selects[j].closest('.tpo_option-container') || selects[j];
        if (!isVisible(holder)) continue;

        total += amountFromText(option.textContent || '');
      }

      return total;
    };

    var lastOptions = null;

    /* Onze eigen optelling is leidend. Easify's totaalregel bleek achter te
       lopen — die toonde de prijs van een accessoire dat allang was uitgevinkt
       — en het verborgen veld _tpo_price wordt pas bij het toevoegen aan de
       winkelwagen gevuld. Allebei dus onbruikbaar om live mee te rekenen.

       De totaalregel lezen we wel uit: daarmee verbergen we hem, zodat er geen
       tweede en verouderd bedrag op de pagina blijft staan. Zijn waarde telt
       alleen nog als er helemaal geen keuzevelden op de pagina zijn.

       Gevolg: een optie waarbij Easify geen bedrag toont, telt niet mee. Zet
       de prijsweergave voor zo'n optie aan in de app, dan pikt dit hem vanzelf
       op — er zit geen enkele optienaam of klassenaam in deze berekening. */
    var resolveCharge = function () {
      var selection = readSelection();
      var notice = chargeFromNotice();

      if (selection !== null) return selection;
      return notice === null ? chargeFromField() : notice;
    };

    var syncOptions = function () {
      var optionCents = resolveCharge();
      if (optionCents === null) optionCents = 0;

      if (optionCents === lastOptions) return;
      lastOptions = optionCents;

      if (optionsRow) {
        var valueEl = optionsRow.querySelector('.gn-buybox__value');
        if (optionCents > 0) {
          optionsRow.removeAttribute('hidden');
          if (valueEl) valueEl.textContent = '+ ' + formatMoney(optionCents);
        } else {
          optionsRow.setAttribute('hidden', '');
          if (valueEl) valueEl.textContent = '';
        }
      }

      var total = formatMoney(basePrice() + optionCents);
      if (totalEl) totalEl.textContent = total;
      if (stickyTotal) stickyTotal.textContent = total;
    };

    // Zodat de variantkiezer het totaal kan laten herberekenen na een wissel.
    refreshOptionTotals = function () {
      lastOptions = null;
      syncOptions();
    };

    syncOptions();

    /* Easify werkt zijn eigen prijzen asynchroon bij: soms meteen, soms pas
       na een netwerkrondje. Eén keer kijken na een klik is dus te weinig —
       we kijken een paar keer met oplopende vertraging, zodat de prijs bij
       elke wijziging meekomt zonder dat je op de interval hoeft te wachten. */
    var burstTimers = [];

    var burst = function () {
      burstTimers.forEach(clearTimeout);
      burstTimers = [0, 50, 120, 250, 500, 900].map(function (delay) {
        return setTimeout(syncOptions, delay);
      });
    };

    // Valt terug op de hele productsectie, voor het geval de app zijn opties
    // buiten .gn-pdp__config rendert.
    var watchRoot = config || pdp;

    if (watchRoot) {
      watchRoot.addEventListener('change', burst);
      watchRoot.addEventListener('input', burst);
      watchRoot.addEventListener('click', burst);
      watchRoot.addEventListener('keyup', burst);

      if ('MutationObserver' in window) {
        new MutationObserver(burst).observe(watchRoot, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'checked', 'value', 'selected'],
        });
      }
    }

    // Vangnet voor wijzigingen die geen van bovenstaande signalen afgeven.
    setInterval(syncOptions, 500);
  }

  /* ---------- Sticky koopbalk ---------- */
  var bar = pdp.querySelector('[data-sticky-bar]');
  var buybox = pdp.querySelector('.gn-buybox');
  if (bar && buybox && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // Toon de balk zodra het koopblok volledig boven de viewport is weggescrold.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(buybox);
  }
})();


/* GlasnuV2: first interaction with product options, once per page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var started = false;
  function trackStart(event) {
    if (started || !event.isTrusted || !event.target.closest) return;
    var option = event.target.closest('.tpo_option-input-inner, .tpo_image-swatches-wrapper, .tpo_radio-button, input[name^="properties["], select[name^="options["], input[name^="options["]');
    if (!option || !root.contains(option)) return;
    started = true;
    var attempts = 0;
    var id = 'config-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    function publish() {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('glasnu_configurator_started', { conversion_id: id });
      } else if (++attempts < 50) {
        setTimeout(publish, 200);
      }
    }
    publish();
  }
  root.addEventListener('click', trackStart, true);
  root.addEventListener('change', trackStart, true);
})();
